import { useMutation } from '@common/hooks';
import { Modal, Form, message } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { EditAssignmentTermForm } from './edit-assignment-term-form';
import { ASSIGNMENT_TERM_MUTATION } from './edit-assignment-term-helper';

export function EditAssignmentTermModal({
  assignmentTermId,
  showModal,
  onClose,
  isExtension,
}) {
  const [form] = Form.useForm();

  const [performAssignmentTermMutation, { loading: mutationLoading }] =
    useMutation(ASSIGNMENT_TERM_MUTATION, {
      onCompleted: (response) => {
        if (response?.upsertAssignmentTerm.errors) {
          const errorMessage =
            response.upsertAssignmentTerm.errors[0].errors[0];
          message.error(`Error: ${errorMessage}`);
        } else {
          message.success('Term has been updated');
          onClose();
        }
      },
      onError: () => message.error('Error occurred, try again later'),
      refetchQueries: ['CandidateAssignmentQuery'],
    });

  const onSubmit = (values) => {
    performAssignmentTermMutation({
      variables: {
        input: {
          ...values,
        },
        assignmentTermId,
      },
    });
  };

  return (
    <>
      <Modal
        className="EditTermModal"
        title="Edit Term"
        visible={showModal}
        onCancel={onClose}
        onOk={form.submit}
        okButtonProps={{ disabled: mutationLoading }}
        okText="Save"
        width={550}
        centered
      >
        <EditAssignmentTermForm
          assignmentTermId={assignmentTermId}
          form={form}
          onSubmit={onSubmit}
          isExtension={isExtension}
          visible={showModal}
        />
      </Modal>
      <style jsx>{`
        :global(.EditTermModal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
}

EditAssignmentTermModal.propTypes = {
  assignmentTermId: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isExtension: PropTypes.bool.isRequired,
};
